// extracted by mini-css-extract-plugin
export var adjacentSlide = "_se-9";
export var arrowButtonContainer = "_se-5";
export var arrowButtonIcon = "_se-6";
export var carouselArrowButton = "_se-2";
export var carouselElementContainer = "_se-1";
export var currentSlide = "_se-8";
export var left = "_se-3";
export var otherSlide = "_se-a";
export var productCarouselContainer = "_se-0";
export var right = "_se-4";
export var sliderOverflow = "_se-7";